import {createTheme} from '@mui/material/styles';

const inputConfig = {
    fullWidth: true,
    color: "primary",
    margin: "none",
    size: "small",
};

const theme = createTheme({
    direction: "ltr",
    typography: {
        fontFamily: ['poppins', "sans-serif"].join(","),
        useNextVariants: true,
        htmlFontSize: 16,
        fontSize: 14,
        fontWeightBold: 700,
        fontWeightLight: 300,
        fontWeightMedium: 500,
        fontWeightRegular: 400,
    },
    palette: {
        mode: "light",
        text: {
            primary: "#333",
            secondary: "#555",
        },
        background: {
            default: "#ccc",
            paper: "rgba(0,0,0,0.1)",
        },
        primary: {
            main: "#333",
        },
        secondary: {
            main: "#333",
        },
    },
    shape: {borderRadius: 2},
    components: {
        MuiCard: {
            defaultProps: {
                style: {
                    backgroundColor: "inherit",
                },
            },
        },
        MuiOutlinedInput: {
            defaultProps: {...inputConfig},
        },
        MuiFormControl: {
            defaultProps: {...inputConfig, variant: "outlined"},
        },
        MuiTextField: {
            defaultProps: {...inputConfig, variant: "outlined"},
        },
        MuiButton: {
            defaultProps: {
                variant: "contained",
                color: "primary",
                size: "small",
                disableElevation: true,
                disableRipple: true,
                disableTouchRipple: true,
                disableFocusRipple: true,
                spellCheck: false,
                // sx : {fontWeight : "bold"}
            },
        },
        MuiLink: {
            defaultProps: {
                style: {cursor: "pointer"},
            },
        },
        MuiStepper: {
            defaultProps: {
                style: {backgroundColor: "transparent"},
            },
        },
        MuiBadge: {
            styleOverrides: {
                badge: {
                    fontWeight: "medium"
                }
            }
        }
    },
});

theme.typography = {
    fontFamily: ["poppins", "sans-serif"].join(","),
    useNextVariants: true,
    htmlFontSize: 16,
    fontSize: 14,

    fontWeightBold: 700,
    fontWeightLight: 400,
    fontWeightMedium: 600,
    fontWeightRegular: 500,


    caption: {
        fontWeight: "regular"
    },
    button: {
        textTransform: "none",
        fontWeight: "regular",
    },
    [theme.breakpoints.only('xs')]: {
        htmlFontSize: 14,
        fontSize: 12,
        body2: {
            fontSize: '0.9rem'
        },
        caption: {
            fontWeight: "regular"
        },
        button: {
            textTransform: "none",
            fontWeight: "regular",
        },
        h1: {
            fontSize: "3rem",
        },
        h2: {
            fontSize: "2.6rem",
        },
        h3: {
            fontSize: '2.3rem',
        },
    }
}

export default theme;
